export default __webpack_public_path__ + "static/media/language2.47eaf12d.png";